<i18n
  src="@/locales/components/views/agro_exporter/production/uniq_final_packing_list/new_package_group.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/package_group.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/package.yml" lang="yaml"></i18n>

<template>
  <div>
    <go-back-link
      :text="$t('labels.go_back_link')"
      :name="routeName('show_container_pallets')"
      :params="{
        agro_exporter_process_id: this.agro_exporter_process_id,
        container_id: this.container_id,
      }"
    >
    </go-back-link>

    <container-header
      :agro_exporter_process_id="agro_exporter_process_id"
      :container_code="container?.container_code"
    />

    <alert-danger :errors_data="std_err" />

    <div v-if="load_general_data" class="mt-8">
      <div class="panel">
        <div class="panel-header">
          <h3 class="panel-header-title">
            {{ $t("labels.title") }}
          </h3>
        </div>
        <div class="panel-body">
          <div class="space-y-8 divide-y divide-gray-200">
            <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div class="sm:col-span-3">
                <label class="label-form">
                  {{ $t("model.package_group.pg_code") }}
                </label>
                <div class="mt-1">
                  <input
                    type="text"
                    v-model="pg_code"
                    :class="['input-text', isInvalid('pg_code')]"
                  />
                </div>
              </div>
              <div class="sm:col-span-3">
                <label class="label-form">
                  {{ $t("model.package_group.grouped_at") }}
                </label>
                <div class="mt-1">
                  <date-form v-model="grouped_at" />
                </div>
              </div>
            </div>
            <div class="pt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div class="sm:col-span-3">
                <label class="label-form">
                  {{ $t("model.package_group.thermo_code") }}
                </label>
                <div class="mt-1">
                  <input
                    type="text"
                    v-model="thermo_code"
                    :class="['input-text', isInvalid('thermo_code')]"
                  />
                </div>
              </div>
              <div class="sm:col-span-6">
                <label class="label-form">
                  {{ $t("model.package_group.comment") }}
                </label>
                <div class="mt-1">
                  <textarea
                    v-model="comment"
                    rows="3"
                    class="input-text-area"
                  />
                </div>
              </div>
            </div>
            <div
              v-for="(package_item, idx) in packages"
              :key="idx"
              class="pt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-8"
            >
              <div class="sm:col-span-8">
                <div class="text-right">
                  <button @click.prevent="removePackage(package_item)" class="text-red-500">
                    <i class="fa-solid fa-close fa-lg px-1"></i>
                  </button>
                </div>
              </div>
              <div class="sm:col-span-4">
                <label class="label-form">
                  {{ $t("model.package_group.producer") }}
                </label>
                <div class="mt-1">
                  <ProducerOrOrgaizationSelect
                    v-if="producers_organizations?.length > 1"
                    :options="producers_organizations"
                    :default_producer_id="package_item.producer_id"
                    :default_organization_id="package_item.organization_id"
                    v-model:producer_id="package_item.producer_id"
                    v-model:organization_id="package_item.organization_id"
                  />
                  <div
                    class="content-data"
                    v-else-if="producers_organizations?.length == 1"
                  >
                    {{ producers_organizations[0].label }}
                  </div>
                </div>
              </div>
              <div class="sm:col-span-2">
                <label class="label-form">{{
                  $t("model.package.exporter_process_crop_size")
                }}</label>
                <div class="mt-1">
                  <select-form
                    v-if="exporter_process_crop_sizes.length > 1"
                    :options="exporter_process_crop_sizes"
                    v-model="package_item.exporter_process_crop_size_id"
                    label="name"
                  />
                  <div
                    class="content-data"
                    v-else-if="exporter_process_crop_sizes.length == 1"
                  >
                    {{ exporter_process_crop_sizes[0].name }}
                  </div>
                </div>
              </div>
              <div class="sm:col-span-2">
                <label class="label-form">{{
                  $t("model.package.quantity")
                }}</label>
                <div class="mt-1">
                  <input
                    type="text"
                    v-model="package_item.quantity"
                    :class="['input-text']"
                  />
                </div>
              </div>

              <package-attrs
                v-if="load_general_data"
                :package_item="package_item"
                :exporter_process_crop_categories="
                  exporter_process_crop_categories
                "
                :exporter_process_crop_varieties="
                  exporter_process_crop_varieties
                "
                :exporter_process_crop_sizes="exporter_process_crop_sizes"
                :exporter_process_crop_packages="exporter_process_crop_packages"
                :exporter_process_brands="exporter_process_brands"
                v-model:quantity.number="package_item.quantity"
                v-model:exporter_process_crop_category_id="
                  package_item.exporter_process_crop_category_id
                "
                v-model:exporter_process_crop_variety_id="
                  package_item.exporter_process_crop_variety_id
                "
                v-model:exporter_process_crop_size_id="
                  package_item.exporter_process_crop_size_id
                "
                v-model:exporter_process_crop_package_id="
                  package_item.exporter_process_crop_package_id
                "
                v-model:exporter_process_brand_id="
                  package_item.exporter_process_brand_id
                "
                :index="idx"
              ></package-attrs>
            </div>
            <div class="col-span-6 sm:col-span-3 text-right py-3">
              <button
                class="border rounded-md px-4 py-1"
                @click.prevent="addPackage()"
              >
                {{ $t("labels.add_package_link") }}
              </button>
            </div>
          </div>
          <div class="sm:flex sm:items-start">
            <div class="mt-3 sm:mt-0 sm:ml-4 sm:text-left sm:w-full">
              <div class="py-5">
                <div class="grid gap-x-4 gap-y-6"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="panel-footer">
          <div class="panel-footer-actions">
            <white-button
              @click.prevent="gotToContainer()"
              :label="$t('labels.cancel_button')"
            />
            <span class="space-actions"></span>
            <success-button
              v-if="!proc_save_button"
              @click.prevent="submit()"
              :label="$t('labels.save_link')"
            />
            <success-button-processing v-else :label="$t('labels.save_link')" />
          </div>
        </div>
      </div>
    </div>
    <loading-message v-else />
  </div>
</template>

<script>
import moment from "moment";

import Requester from "@/views/agro_exporter/requesters/production/uniq_final_packing_list/clone_package_group.js";

import PackageAttrs from "@/components/views/agro_exporter/production/uniq_final_packing_list/show_container/tabs/packages/PackageAttrs.vue";
import ProducerOrOrgaizationSelect from "@/components/views/agro_exporter/production/uniq_final_packing_list/ProducerOrOrganizationSelect.vue";
import ContainerHeader from "@/components/views/agro_exporter/production/uniq_final_packing_list/ContainerHeader.vue";

export default {
  name: "ClonePackageGroup",
  components: {
    ContainerHeader,
    PackageAttrs,
    ProducerOrOrgaizationSelect,
  },
  emit: ["update:packages-groups"],
  props: {
    agro_exporter_id: { required: true },
    agro_exporter_process_id: { required: true },
    container_id: { required: true },
    package_group_id: {
      required: true,
    },
  },
  data() {
    return {
      load_general_data: false,
      proc_save_button: false,
      container: null,
      comment: "",
      pg_code: "",
      grouped_at: null,
      thermo_code: "",
      packages: [],
      producers_organizations: null,
      exporter_process_crop_categories: [],
      exporter_process_crop_varieties: [],
      exporter_process_crop_sizes: [],
      exporter_process_crop_packages: [],
      exporter_process_brands: [],
    };
  },
  computed: {
    default_producer_id: function () {
      if (Number(this.producers_organizations?.length) == 1)
        return this.producers_organizations[0].producer_id ?? null;
      return null;
    },
    default_organization_id: function () {
      if (Number(this.producers_organizations?.length) == 1)
        return this.producers_organizations[0].organization_id ?? null;
      return null;
    },
    grouped_at_formatted: function () {
      return moment(this.grouped_at).format("YYYY-MM-DD");
    },
  },
  methods: {
    loadData: async function () {
      await this.getExporterProcessCropCategories();
      await this.getExporterProcessCropVarieties();
      await this.getExporterProcessCropSizes();
      await this.getExporterProcessCropPackages();
      await this.getExporterProcessBrands();
      this.load_general_data = true;
    },
    addPackage: function () {
      this.packages.push({
        producer_id: this.default_producer_id,
        organization_id: this.default_organization_id,
        exporter_process_crop_package_id: this.hasOneItem(this.exporter_process_crop_packages),
        exporter_process_crop_category_id: this.hasOneItem(this.exporter_process_crop_categories),
        exporter_process_crop_variety_id: this.hasOneItem(this.exporter_process_crop_varieties),
        exporter_process_crop_size_id: this.hasOneItem(this.exporter_process_crop_sizes),
        exporter_process_brand_id: this.hasOneItem(this.exporter_process_brands),
        quantity: null,
      });
    },
    cleanData: function () {
      this.pg_code = "";
      this.comment = "";
      this.thermo_code = "";
    },
    fetchContainer: async function () {
      let response = await Requester.fetchContainer({
        container_id: this.container_id,
      });
      this.container = response.data;
    },
    fetchPackageGroup: async function () {
      let response = await Requester.fetchPackageGroup({
        package_group_id: this.package_group_id,
        container_id: this.container_id,
      });
      this.fillInitalData(response.data);
    },
    fetchProducersOrganizations: async function () {
      let response = await Requester.fetchProducersOrganizations(
        this.agro_exporter_process_id
      );
      this.producers_organizations = response.data;
    },
    getExporterProcessCropCategories: async function () {
      let response = await Requester.fetchExportProcessCropCategories(
        this.agro_exporter_process_id
      );

      this.exporter_process_crop_categories = response.data;
    },
    getExporterProcessCropVarieties: async function () {
      let response = await Requester.fetchExportProcessCropVarieties(
        this.agro_exporter_process_id
      );

      this.exporter_process_crop_varieties = response.data;
    },
    getExporterProcessBrands: async function () {
      let response = await Requester.fetchExportProcessBrands(
        this.agro_exporter_process_id,
        this.container_id
      );

      this.exporter_process_brands = response.data;
    },
    getExporterProcessCropPackages: async function () {
      let response = await Requester.fetchExportProcessCropPackages(
        this.agro_exporter_process_id
      );

      this.exporter_process_crop_packages = response.data;
    },
    getExporterProcessCropSizes: async function () {
      let response = await Requester.fetchExportProcessCropSizes(
        this.agro_exporter_process_id
      );

      this.exporter_process_crop_sizes = response.data;
    },
    fillInitalData: function (package_group) {
      this.pg_code = package_group.pg_code;
      this.comment = package_group.comment;
      this.thermo_code = package_group.thermo_code;
      this.grouped_at = package_group.grouped_at;
      this.packages = package_group.packages.map((package_item) => {
        return {
          ...package_item,
          id: null,
        };
      });
    },
    goToContainer: function () {
      this.$router.push({
        name: "ae_production_uniq_final_packing_list_show_container_path",
        params: {
          agro_exporter_process_id: this.agro_exporter_process_id,
          container_id: this.container_id,
        },
      });
    },
    submit: async function () {
      this.proc_save_button = true;
      try {
        let response = await Requester.createPackageGroup({
          container_id: this.container_id,
          agro_exporter_process_id: this.agro_exporter_process_id,
          pg_code: this.pg_code,
          comment: this.comment,
          thermo_code: this.thermo_code,
          grouped_at: this.grouped_at_formatted,
          packages: this.packages,
        });
        this.registerSuccessNotification({
          title: response.data.success_message,
        });
        this.goToContainer();
      } catch (error) {
        if (error.response.status == 422) {
          this.loadStandardErrorMessages({
            title: error.response.data.error_title,
            messages: error.response.data.error_messages,
            fields: error.response.data.error_fields,
          });
        }
      }
      this.proc_save_button = false;
    },
    removePackage: function (package_item) {
      this.packages.splice(this.packages.indexOf(package_item), 1);
    },
    hasOneItem(arr) {
      return arr.length === 1 ? arr[0].id : null;
    },
    gotToContainer: function () {
      this.$router.push({
        name: this.routeName("show_container_pallets"),
        params: {
          agro_exporter_process_id: this.agro_exporter_process_id,
          container_id: this.container_id,
        },
      });
    },
  },
  created: function () {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          agro_exporter_id: this.agro_exporter_id,
        },
      }).then(() => {
        this.fetchContainer();
        this.fetchProducersOrganizations();
        this.fetchPackageGroup().then(() => this.loadData());
      })
    );
  },
};
</script>

<style></style>
